import { Avatar, Box, Button, Grid, IconButton, ImageList, ImageListItem, LinearProgress, Modal, Paper, Rating, TextField, Tooltip, Typography } from "@mui/material";
import Navbar from "./Navbar";
import { Book, CalendarMonth, Call, Cancel, DateRange, Directions, Facebook, Instagram, MiscellaneousServices, Reviews, Star, StarBorder, Toys, X } from "@mui/icons-material";
import { useLocation, useOutletContext, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from 'axios';
import 'mapbox-gl/dist/mapbox-gl.css';
import * as mapboxgl from 'mapbox-gl'
import Footer from "./Footer";
import { formatDistanceToNow, formatDistanceToNowStrict, set } from 'date-fns'


// const {styles}

function srcset(image: string, size: number, rows = 1, cols = 1) {
    return {
        src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
        srcSet: `${image}?w=${size * cols}&h=${size * rows
            }&fit=crop&auto=format&dpr=2 2x`,
    };
}
export default function Product() {




    // const mapRef = useRef()
    // const mapContainerRef = useRef()

    // useEffect(() => {
    //     mapboxgl.accessToken = ''
    //     mapRef.current = new mapboxgl.Map({
    //         container: mapContainerRef.current,
    //     });

    //     return () => {
    //         mapRef.current.remove()
    //     }
    // }, [])

    const { shopSlug } = useParams();
    const shopId = shopSlug.split("-").pop();

    var url = `http://localhost:${process.env?.PORT || 3000}/`;
    const [data, setdata] = useState({});
    const [gallery, setgallery] = useState([]);
    const [featuredImages, setFeaturedImages] = useState([]);
    const [services, setservices] = useState([]);
    function getShop() {
        if (shopId) {
            axios.post(url + 'getShop', {
                Id: shopId
            }).then((succ) => {
                console.log(succ.data);
                setdata(succ.data);
                setgallery(succ.data.Gallery);
                setFeaturedImages(succ.data.FeaturedImages)
                setPhoneNumber(`+91${succ.data?.Phone}`)
                setservices(succ.data.Services)
                // console.log(succ.data.Review)
            })
        }
    }
    useEffect(() => {
        getShop();
    }, [shopId])


    const [reviews, setreviews] = useState([]);
    const [showall, setshowall] = useState(false);
    const [totalReviews, setTotalReviews] = useState(0);
    function fetchReviews() {
        if (shopId) {
            axios.post(url + 'salon/review/fetch', {
                ShopId: shopId
            }).then((succ) => {
                var data = succ.data;
                if (data.response == 'failed') {
                    alert(data.reason);
                } else {
                    // console.log(succ.data.results)
                    setreviews(data.results)
                    if (data.results.length > 4) {
                        setreviews(data.results.slice(0, 4));
                        setshowall(true);
                        setAllReviews(data.results)
                    } else {
                        setreviews(data.results);
                    }
                    setTotalReviews(data.results.length);
                }
            })
        }
    }

    useEffect(() => {
        fetchReviews();
    }, [shopId])

    async function addReview(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var Rating = data.get('rating');
        var Review = data.get('review');
        var useruid = localStorage.getItem('useruid');
        // if (!useruid) {
        //     return alert('error fetching user credentials');
        // }
        try {
            handleClose();
            const result = await axios.post(url + 'salon/review/add', {
                ShopId: shopId,
                RatingGiven: Number(Rating),
                Review: Review,
                UserId: useruid
            })
            if (result.data.response == 'success') {
                alert('added');
                e.target.reset();
                fetchReviews();
            } else if (result.data.response == 'failed') {
                alert(result.data.reason);
            }
            // .then((succ) => {
            //     if (succ.data == 'success') {
            //         alert('added')
            //     } else {
            //         alert('please try again later.')
            //     }
            // })
        } catch (error) {
            console.log(error);
        }
    }


    const mapRef = useRef();
    const mapContainerRef = useRef();

    useEffect(() => {
        if (!data?.Lat || !data?.Long) return;

        mapboxgl.accessToken = 'pk.eyJ1IjoibmFrc2hzaGFybWEiLCJhIjoiY21sMTdlNmZmMDR3bTNlc2FubmRveWE1ciJ9.FUCHDeqJcf1GrgdiPTIRiQ';

        // prevent creating map twice
        if (mapRef.current) return;

        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [data.Long, data.Lat],
            zoom: 15,
            minZoom: 7
        });

        // add navigation controls
        mapRef.current.addControl(new mapboxgl.NavigationControl());

        // add marker
        new mapboxgl.Marker({ color: '#069CD0' })
            .setLngLat([data.Long, data.Lat])
            .setPopup(
                new mapboxgl.Popup().setHTML(
                    `<h4>${data.Name}</h4><p>${data.Address}</p>`
                )
            )
            .addTo(mapRef.current);

        return () => {
            mapRef.current?.remove();
            mapRef.current = null;
        };
    }, [data]);


    const callButtonRef = useRef(null);
    const { setShowNavbar, setPhoneNumber } = useOutletContext();
    useEffect(() => {
        const element = callButtonRef.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setShowNavbar(!entry.isIntersecting);
            },
            { threshold: 0.1 }
        );

        observer.observe(element);
        return () => observer.disconnect();
    }, []);
    // useEffect(() => {
    //     const handleScroll = () => {
    //         const rect = callButtonRef.current?.getBoundingClientRect();
    //         if (!rect) return;

    //         setShowNavbar(rect.bottom < 100);
    //     };

    //     window.addEventListener("scroll", handleScroll);
    //     return () => window.removeEventListener("scroll", handleScroll);
    // }, []);

    // var uri = new URLSearchParams(useLocation().search).get('id');


    const [cart, setcart] = useState([]);
    // function addtocart(x) {
    //     if (cart.length > 0) {
    //         if (cart.indexOf(x) <= 0) {
    //             setcart(...cart, x);
    //         }
    //     } else {
    //         cart.push(x)
    //     }
    //     console.log(cart)
    // }
    // const [services, setservices] = useState([
    //     { Name: 'Hair cut', Price: 300, Img: '', Time: 30 },
    //     { Name: 'Beard Styling/ Shave', Price: 400, Img: '', Time: 40 },
    //     { Name: 'Facial', Price: 350, Img: '', Time: 90 },
    //     { Name: 'Cleansing', Price: 200, Img: '', Time: 30 },
    //     { Name: 'Scrubbing', Price: 350, Img: '', Time: 20 },
    //     { Name: 'Detan Treament', Price: 300, Img: '', Time: 35 },
    //     { Name: 'Head Massage', Price: 250, Img: '', Time: 30 },
    //     { Name: 'Neck Massage', Price: 500, Img: '', Time: 50 },
    //     { Name: 'Shoulder Massage', Price: 300, Img: '', Time: 30 },
    //     { Name: 'Hair Colorin', Price: 290, Img: '', Time: 40 },
    //     { Name: 'Pedicures', Price: 320, Img: '', Time: 30 },
    //     { Name: 'Manicures', Price: 400, Img: '', Time: 25 },
    //     { Name: 'Body Waxing', Price: 320, Img: '', Time: 35 },
    // ]);

    const [modal, setmodal] = useState(false);

    const handleOpen = () => {
        setmodal(true);
    }

    const handleClose = () => {
        setmodal(false);
    }

    function addtocart(item) {
        setcart(prevCart => {
            if (prevCart.indexOf(item) !== -1) {
                return prevCart; // already exists
            }
            return [...prevCart, item]; // add new item
        });
        // console.log(cart)
        // function pay(params) {
        // totalMoney()
        // }
    }
    const Totalsum = cart.reduce((accumalator, cItem) => {
        return accumalator + cItem.Price;
    }, 0)
    const Totaltime = cart.reduce((accumalator, cItem) => {
        return accumalator + cItem.Time;
    }, 0)
    // function totalMoney() {
    // for (let i = 0; i < cart.length; i++) {

    // }
    // }

    function removefromcart(item) {
        setcart(prevCart => {
            const index = prevCart.indexOf(item);

            if (index === -1) return prevCart; // not found

            const newCart = [...prevCart];
            newCart.splice(index, 1); // remove item at index
            return newCart;
        });
    }

    const [currentSection, setcurrentSection] = useState(0);

    const [tabs, settabs] = useState(['Overview', 'Reviews', 'Gallery', 'Services', 'Book Appointment']);
    const [selectedtab, settab] = useState(0);


    const [allReviews, setAllReviews] = useState([]);
    const [showAllReviews, setShowAllReviews] = useState(false);
    // const [reviews,setreviews]  = useState([]);
    // function fetchReviews() {
    //     if (shopId) {
    //         axios.post(url + 'fetchReviews', {
    //             Id: shopId
    //         }).then((succ) => {
    //             setreviews(succ.data.reviews)
    //         })
    //     }
    // }
    // useEffect(() => {
    // fetchReviews();
    // }, [shopId])

    const [galleryimgs, setgalleryimgs] = useState(['https://s3-media0.fl.yelpcdn.com/bphoto/hVOcBelyVuDNLdeQJUowJw/348s.jpg', 'https://s3-media0.fl.yelpcdn.com/bphoto/_PPVuQoFSLErLPIUvKVdSA/l.jpg', 'https://s3-media0.fl.yelpcdn.com/bphoto/xPEHGFt8pylFvnY43WOVxw/l.jpg', 'https://s3-media0.fl.yelpcdn.com/bphoto/zRPW3mDdfmHIVDexaR6Plg/l.jpg', 'https://s3-media0.fl.yelpcdn.com/bphoto/2G6VnI1viLF4YR9t2AN-HQ/l.jpg', 'https://s3-media0.fl.yelpcdn.com/bphoto/JfduD4VDmL9EGldOY_MwtA/o.jpg', 'https://lh3.googleusercontent.com/gps-cs-s/APNQkAHVqkIxX9b3qEVn8CB8V3eiq9dv2bRjIXrF_UU2q8dwc12HGuKYknzdmjy0tLMImVAEVqdZ1XeJtGUU46ON8b0QglrpPuSjjDmZRPjhrCkzUdyxDYhwK7KjE-RSyY4MxMI4TcDCnM0-WzYd=w568-h568-n-k-rw-no-v1', 'https://s3-media0.fl.yelpcdn.com/bphoto/xPEHGFt8pylFvnY43WOVxw/l.jpg']);


    const [showBorder, setShowBorder] = useState(false);
    const handleScroll = (e) => {
        const currentScroll = e.currentTarget.scrollTop;
        // console.log(currentScroll);
        if (currentScroll > 5) {
            setShowBorder(true)
        } else {
            setShowBorder(false);
        }
    }

    const [galleryIndex, setGalleryIndex] = useState(null)

    const handleExternalRedirect = (url) => {
        var finalUrl = url
        if (url.indexOf('http://') == -1 && url.indexOf('https://') == -1) {
            finalUrl = `http://${url}`
        }
        window.location.href = finalUrl;
    }

    return (
        <>

            <Grid minHeight={'100vh'} width={'100%'} bgcolor={'white'}>
                {/* <Navbar /> */}

                <Grid container justifyContent={'space-between'}>
                    <div className="col-12">
                        <div className="">
                            {/* <div className="col-lg-10"> */}
                            {/* <div className="row m-0 p-4 justify-content-between align-items-center mt-1">
                                    <div className="col-lg-7 ps-0">
                                        <Tooltip title={data.Name} arrow placement="top">
                                            <Typography variant="h4" fontWeight={550}>{data?.Name?.substr(0, 29)}{data.Name?.length > 32 && "..."}</Typography>
                                        </Tooltip>
                                    </div>
                                    <div className="col-lg-5">
                                        <button className="btn-green float-end">Open till 7:00 pm today</button>
                                    </div>
                                    <div className="col-lg-7 mt-1 ps-0">
                                        <Typography fontSize={27} mt={2}>
                                            <Call sx={{ fontSize: 25,  }} />
                                            <span className="ms-2">+91 {data.Phone}</span>
                                        </Typography>
                                    </div>
                                    <div className="col-lg-5 mt-2">
                                        <span className="justify-content-end row m-0 align-items-center">
                                            4.0 <Rating readOnly value={4} precision={1} />
                                        </span>
                                    </div>
                                    <Typography className="ps-0" variant="h5" mt={2}>{data.Address}</Typography>
                                </div> */}

                            {/* </div> */}
                            {/* <div className="row m-0 p-0 px-4 align-items-center justify-content-between">
                                <Typography fontWeight={'bold'} className="col-lg-8 ps-0" variant="h4">{data.Name}</Typography>
                            </div> */}
                            <Box className='image-gallery-cont'>
                                {featuredImages?.length > 0 ? (

                                    featuredImages?.map((row, index) => (
                                        <>
                                            <Box className={index == 0 ? 'wide-img' : index == 1 ? 'small-img1' : index == 2 ? 'small-img2' : 'last-img'}>
                                                <img src={row?.url || require('./imgs/placeholder.avif')} className="gallery-img" />
                                            </Box>
                                        </>
                                    ))
                                ) : (
                                    [1, 2, 3, 4].map((row, index) => (
                                        <Box className={index == 0 ? 'wide-img' : index == 1 ? 'small-img1' : index == 2 ? 'small-img2' : 'last-img'}>
                                            <img src={row?.url || require('./imgs/placeholder.avif')} className="gallery-img" />
                                        </Box>
                                    ))
                                )}

                            </Box>
                            <div className="row m-0 justify-content-between px-4">
                                <Grid mt={4} className="col-lg-6 px-0">
                                    <Grid border={'1px solid #000'} p={3} borderRadius={1} className="row m-0 justify-content-between align-items-end mt-1">
                                        <div className="col-9 p-0">
                                            <Tooltip title={data.Name} arrow placement="top-start">
                                                <Typography variant="h5" fontWeight={550}>{data?.Name?.substr(0, 30)}{data.Name?.length > 27 && "..."}</Typography>
                                            </Tooltip>
                                        </div>
                                        <div className="col-3">
                                            <img src={require('./imgs/open.png')} className="open_now_name float-end" />
                                        </div>
                                        {/* <div className="col-lg-5">
                                                    <button className="btn-green float-end">Open till 7:00 pm today</button>
                                                </div> */}
                                        <Grid mt={1} container className='p-0' alignItems={'center'} justifyContent={'space-between'}>
                                            {/* <Grid bgcolor={'blue'} size={{ lg: 7.5 }}> */}
                                            <Typography lineHeight={'1'} className="ps-0 col-lg-9" variant="h6">{data.Address}</Typography>
                                            {/* </Grid> */}
                                            <Grid container justifyContent={'space-between'} alignItems={'center'} className='col-lg-2'>

                                                {data?.SocialLinks?.map((row) => (
                                                    row.Url != '' && (
                                                        <Tooltip title={row.Platform + ' Link'}>
                                                            <IconButton onClick={() => handleExternalRedirect(row.Url)} size="small">
                                                                {row.Platform == 'Instagram' ? (
                                                                    <Instagram />
                                                                ) : row.Platform == 'Facebook' ? (
                                                                    <Facebook />
                                                                ) : <X />}
                                                            </IconButton>
                                                        </Tooltip>
                                                    )
                                                ))}

                                                {/* <IconButton size="small">
                                                    <Instagram />
                                                </IconButton>
                                                <IconButton size="small">
                                                    <Facebook />
                                                </IconButton>
                                                <IconButton size="small">
                                                    <X />
                                                </IconButton> */}
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'space-between'} px={0}>
                                            <Grid size={{ md: 5.5, xs: 12 }} >
                                                <div ref={callButtonRef} className="w-100">
                                                    <a href={`tel:+91${data.Phone}`} className="text-white text-decoration-none">
                                                        <Button sx={{ mt: 2 }} startIcon={
                                                            <Call sx={{ fontSize: 22, }} />
                                                        } variant="contained" color="primary" className="w-100 ">
                                                            <Typography variant="h6">+91 {data.Phone}</Typography>
                                                        </Button>
                                                    </a>
                                                </div>
                                            </Grid>
                                            <Grid size={{ md: 5.5, xs: 12 }}>
                                                <a href={`https://www.google.com/maps/dir/?api=1&destination=${data.Lat},${data.Long}&travelmode=driving`} target="_blank">
                                                    <Button startIcon={
                                                        <Directions />
                                                    } sx={{ textTransform: 'capitalize', mt: 2 }} variant="outlined" color="primary" className="w-100">
                                                        <Typography variant="h6" className="d-sm-none  d-md-block"> Get Directions</Typography>
                                                    </Button>
                                                </a>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid p={3} bgcolor={"rgb(239, 241, 243)"} className='rounded mt-4'>
                                        <Grid style={{
                                            width: '100%',
                                            height: '40vh',
                                            borderRadius: '12px',
                                            // marginTop: 20,
                                            border: '1px solid black',
                                            display: selectedtab === 0 ? 'block' : 'none'
                                        }} id="map-container" ref={mapContainerRef}></Grid>
                                    </Grid>

                                    <Typography variant="h4" fontWeight={'bold'} pt={4} pb={2}>Services:</Typography>

                                    <Grid container justifyContent={'space-between'}>
                                        {services?.map((row) => (
                                            <Grid mt={2} borderRadius={1} textAlign={'center'} size={{ lg: 3.7 }}>
                                                <Avatar src={'https://s3-media0.fl.yelpcdn.com/bphoto/qeUIOWujdolugo6Jb6cs0Q/348s.jpg'} sx={{
                                                    width: 140, height: 140, border: '1px solid #000',
                                                    marginInline: 'auto'
                                                }} />
                                                <Typography mt={2} variant="body1" fontWeight={'bold'}>{row.Name}</Typography>
                                            </Grid>
                                        ))}
                                        {/* {[1, 2, 3].map((row) => (

                                            <Grid mt={2} borderRadius={1} textAlign={'center'} size={{ lg: 3.7 }}>
                                                <Avatar src={require('./imgs/noun-woman-5903983-removebg-preview.png')} sx={{
                                                    width: 140, height: 140, border: '1px solid #000',
                                                    marginInline: 'auto'
                                                }} />
                                                <Typography mt={2} variant="body1" fontWeight={'bold'}>Women's Hair Cut</Typography>
                                            </Grid>
                                        ))} */}
                                    </Grid>
                                    <Typography variant="h4" fontWeight={'bold'} py={4}>Hours</Typography>


                                    <Grid bgcolor={"rgb(239, 241, 243)"} size={{ lg: 8 }} borderRadius={2} container className='pb-3' pt={0} px={3}>
                                        {[1, 2, 3, 4, 5, 6, 7].map((row, index) => (
                                            <>
                                                <Typography className="col-5 mt-3 d-flex align-items-center" color={index != 6 ? "success" : 'error'} variant="h6" fontWeight={500}>
                                                    {index != 6 ? 'Monday' : 'Sunday'}
                                                </Typography>
                                                <Typography fontWeight={index != 6 ? 500 : 600} className="col-7 mt-3 d-flex justify-content-end" variant="h6">{index != 6 ? '10:00 AM - 7:00 PM' : 'Closed'}</Typography>
                                            </>
                                        ))}
                                    </Grid>

                                </Grid>
                                <Grid size={{ lg: 5.5, xs: 12 }} mt={4} className="col-lg-6 col-sm-12 px-0">
                                    <Grid container pt={0} justifyContent={'space-between'}>
                                        <Grid display={'block'} size={{ lg: 12, md: 6, xs: 12 }}>
                                            <Grid bgcolor={"rgb(239, 241, 243)"} p={3} borderRadius={2} container alignItems="center">
                                                {totalReviews == 0 ? (
                                                    <>
                                                        <Typography>This Salon hasnt been reviewed yet. </Typography>
                                                    </>
                                                ) : (

                                                    <>
                                                        <Typography lineHeight={1} className="w-100 mb-0" variant="h5">Reviews</Typography>
                                                        <Grid mt={1.5} container mb={3} justifyContent={'space-between'} px={0} alignItems={'center'} width={'100%'}>
                                                            <Grid m={0} display={'flex'} alignItems={'center'} className="p-0 col-lg-8">
                                                                <Rating value={Number(data.AvgRating).toFixed(1)} className="px-0" readOnly precision={.5} />
                                                                {/* <Typography variant="h6" ml={2}>4.9</Typography> */}
                                                            </Grid>
                                                            <Typography variant="h6" className="text-secondary">({totalReviews} review{totalReviews != 1 && 's'})</Typography>
                                                        </Grid>

                                                        <Grid display={'flex'}
                                                            flexDirection={'column'}
                                                            justifyContent={'space-between'} alignItems={'center'} size={{ xs: 12, md: 3 }}>
                                                            <Typography variant="h2" fontWeight={500}>
                                                                {Number(data.AvgRating).toFixed(1)}
                                                            </Typography>

                                                        </Grid>

                                                        {/* Ratings Breakdown */}
                                                        <Grid

                                                            size={{ xs: 12, md: 9 }}>
                                                            {[5, 4, 3, 2, 1].map((rating) => (
                                                                <Grid
                                                                    key={rating}
                                                                    container
                                                                    alignItems="center"
                                                                    spacing={2}
                                                                    sx={{ mb: 2.5 }}
                                                                >
                                                                    <Grid size={{ xs: 1 }}>
                                                                        <Typography textAlign="center">
                                                                            {rating}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid size={{ xs: 11 }}>
                                                                        <LinearProgress
                                                                            variant="determinate"
                                                                            value={75}
                                                                            sx={{
                                                                                // height: 12,
                                                                                borderRadius: 1,
                                                                                bgcolor: '#E5E5E5',
                                                                                '& .MuiLinearProgress-bar': {
                                                                                    backgroundColor: '#FAAF00',
                                                                                    borderRadius: 10,
                                                                                },
                                                                                py: .8
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                            {/* {[reviews && reviews.length] > 0 ? ( */}
                                            {reviews?.map((row, index) => (
                                                <Grid bgcolor={"rgb(239, 241, 243)"} p={3} className=' col-lg-12 mt-4 float-end review-card rounded'
                                                // sx={index == 0 ? ({ borderBlock: '1px solid black' }) : { borderBottom: '1px solid black' }}
                                                >
                                                    <Grid container justifyContent={'space-between'} alignItems={'center'}>
                                                        <Grid container size={{ lg: 7 }} alignItems={'center'}>
                                                            <Avatar
                                                                alt="Remy Sharp"
                                                                src="https://b.zmtcdn.com/data/user_profile_pictures/51e/b1004de7ed3df4783159544aa850c51e.jpg?fit=around%7C100%3A100&crop=100%3A100%3B%2A%2C%2A"
                                                                sx={{ width: 50, height: 50, border: '1px solid black' }}
                                                                variant="rounded"
                                                            />
                                                            <Typography pl={1.5} py={0} lineHeight={1} variant="h6" fontWeight={'bold'} >Jhon Doe</Typography>
                                                        </Grid>
                                                        <Rating readOnly name="half-rating" value={row.Rating} precision={0.5} />
                                                        {/* <Grid size={{lg:5}}> */}

                                                        {/* </Grid> */}
                                                    </Grid>
                                                    <Grid mt={3} size={{ lg: 12 }}>
                                                        <Typography className="text-secondary" variant="body1">
                                                            {row?.Review}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid container justifyContent={'end'} mt={1}>
                                                        {/* {formatDistanceToNow(row.CreatedAt)} ago */}
                                                        {formatDistanceToNowStrict(
                                                            new Date(row.CreatedAt),
                                                            { addSuffix: true }
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </Grid>

                                        <Grid width={'100%'} mt={3} container justifyContent={'space-between'} borderRadius={1} bgcolor={"rgb(239, 241, 243)"} p={2}>
                                            <Button onClick={handleOpen} startIcon={
                                                <Reviews />
                                            } variant="outlined" sx={{ px: 3 }}>
                                                Write a review
                                            </Button>
                                            <Typography onClick={() => setShowAllReviews(true)} variant="h6" sx={{ opacity: showall ? 1 : 0 }} className="cursor-pointer text-primary">View all {totalReviews} reviews</Typography>
                                            <Modal open={showAllReviews} onClose={() => setShowAllReviews(false)}>
                                                <Box className='show_all_reviews'>
                                                    <Grid container alignItems={'center'} justifyContent={'space-between'}>
                                                        <Typography lineHeight={1} variant="h4">Reviews({totalReviews})</Typography>
                                                        <IconButton onClick={() => setShowAllReviews(false)} sx={{ padding: 0 }}>
                                                            <Cancel sx={{ fontSize: 30 }} />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid onScroll={handleScroll} mt={3} sx={{ overflowY: 'auto', flexGrow: 1, }}>
                                                        {allReviews.map((row, index) => (
                                                            <Grid mt={index != 0 && 3} bgcolor={"rgb(239, 241, 243)"} p={3} className='w-100 float-end review-card rounded'
                                                            // sx={index == 0 ? ({ borderBlock: '1px solid black' }) : { borderBottom: '1px solid black' }}
                                                            >
                                                                <Grid className='w-100' container justifyContent={'space-between'} alignItems={'center'}>
                                                                    <Grid container size={{ lg: 7 }} alignItems={'center'}>
                                                                        <Avatar
                                                                            alt="Remy Sharp"
                                                                            src="https://b.zmtcdn.com/data/user_profile_pictures/51e/b1004de7ed3df4783159544aa850c51e.jpg?fit=around%7C100%3A100&crop=100%3A100%3B%2A%2C%2A"
                                                                            sx={{ width: 50, height: 50, border: '1px solid black' }}
                                                                            variant="rounded"
                                                                        />
                                                                        <Typography pl={1.5} py={0} lineHeight={1} variant="h6" fontWeight={'bold'} >Jhon Doe</Typography>
                                                                    </Grid>
                                                                    <Rating readOnly name="half-rating" value={row.Rating} precision={0.5} />
                                                                    {/* <Grid size={{lg:5}}> */}

                                                                    {/* </Grid> */}
                                                                </Grid>
                                                                <Grid mt={2} size={{ lg: 12 }}>
                                                                    <Typography className="text-secondary mt-1" variant="body1">
                                                                        {row?.Review}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid container justifyContent={'end'} mt={2}>
                                                                    {/* {formatDistanceToNow(row.CreatedAt)} ago */}
                                                                    {formatDistanceToNowStrict(
                                                                        new Date(row.CreatedAt),
                                                                        { addSuffix: true }
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Box>
                                            </Modal>
                                            <Modal open={modal} onClose={handleClose}>
                                                <Box className='write_a_review'>
                                                    <Typography textAlign={'center'} variant="subtitle1">{data.Name}</Typography>
                                                    <Typography className="mt-3" lineHeight={1} variant="h5">Add a Review</Typography>
                                                    <form onSubmit={addReview}>
                                                        <center className="py-3">
                                                            <Rating size="large" name="rating" defaultValue={3} />
                                                        </center>
                                                        <textarea className="form-control resize-none" name="review" rows={4} placeholder="Write a review"></textarea>
                                                        <Grid container className='mt-3' justifyContent={'space-between'}>
                                                            <Grid size={{ lg: 5.5 }}>
                                                                <Button onClick={handleClose} variant="contained" fullWidth>
                                                                    <Typography variant="body1">Cancel</Typography>
                                                                </Button>
                                                            </Grid>
                                                            <Grid size={{ lg: 5.5 }}>
                                                                <Button type="submit" variant="outlined" fullWidth>
                                                                    <Typography variant="body1">Post</Typography>
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </form>
                                                </Box>
                                            </Modal>
                                        </Grid>

                                        {/* <Grid size={{ lg: 5, md: 5 }}>
                                                    <form onSubmit={addReview}>
                                                        <TextField placeholder="Write a Review" multiline name="review" rows={6} className="w-100" />
                                                        <Rating defaultValue={4} name="rating" precision={1} className="mt-2" />
                                                        <button type="submit" className="btn-admin-navy mt-1 py-2 w-100">Add Review</button>
                                                    </form>
                                                </Grid> */}
                                    </Grid>
                                </Grid>
                            </div>

                            <Grid className='px-4'>
                                <Typography variant="h4" fontWeight={'bold'} py={4}>Gallery</Typography>
                                <Grid className='salon_gallery_cont_frontend p-0'>
                                    {gallery?.map((row, index) => (
                                        <>
                                            <img onClick={() => setGalleryIndex(index)} className="cursor-pointer" src={row} />
                                            <Modal open={index == galleryIndex} onClose={() => setGalleryIndex(null)}>
                                                <Box className='gallery_box'>
                                                    <IconButton className="gallery_button cursor" onClick={() => setGalleryIndex(null)} sx={{ padding: 0 }}>
                                                        <Cancel sx={{ fontSize: 30 }} />
                                                    </IconButton>
                                                    <img src={row} />
                                                </Box>
                                            </Modal>
                                        </>
                                    ))}
                                </Grid>
                            </Grid>


                            {/* <Typography className="mt-3" fontWeight={'bold'} variant="h4">{data.Name}</Typography> */}
                            {/* <div className="row m-0 justify-content-between mt-3">

                                <button className="btn-service col-2"><MiscellaneousServices /> Services</button>

                                <div className="col-6">
                                    <button onClick={handleOpen} className="btn-service"><CalendarMonth /> &nbsp;Book Appointment(Pay at Salon)</button>
                                    <Modal
                                        open={modal}
                                        onClose={handleClose}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <Box sx={style}>
                                            {(currentSection == 0) ? (
                                                <>
                                                    <Typography id="modal-modal-title" variant="h6" component="h2">
                                                        Choose Service(s)
                                                    </Typography>
                                                    <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                                                        {services.map((row) => (
                                                            <div className="d-flex justify-content-between mt-1 align-items-center">
                                                                <div className="col-4">{row.Name}</div>
                                                                <div className="col-4"><span className="float-end">${row.Price}</span></div>
                                                                <div className="col-4">
                                                                    {cart.indexOf(row) != -1 ? (
                                                                        <button onClick={() => removefromcart(row)} className="btn btn-info float-end">remove</button>
                                                                    ) : (
                                                                        <button onClick={() => addtocart(row)} className="btn btn-navy float-end">Select</button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <div className="d-flex flex-wrap justify-content-between mt-3 align-items-center">
                                                            <Typography variant="h6" className="col-8">Total Money(to be paid at Shop):</Typography>
                                                            <Typography variant="h6" className="col-4" textAlign={'right'}>${Totalsum}</Typography>
                                                            <Typography variant="h6" className="col-8">Time Duration:</Typography>

                                                            <Typography className="col-4" variant="h6" textAlign={'right'}>{Totaltime} mins</Typography>
                                                        </div>
                                                        <button className="btn btn-navy mt-3 float-end px-3" onClick={() => setcurrentSection(1)} disabled={(cart.length == 0)}>Next</button>

                                                    </Typography>
                                                </>
                                            ) : currentSection == 1 ? (
                                                <>


                                                </>
                                            ) : (
                                                <></>
                                            )}
                                        </Box>
                                    </Modal>
                                </div>
                                <button className="btn-service col-2"><Directions /> Directions</button>
                            </div> */}
                            <br />
                            <br />
                            {/* <Typography variant="h4" fontWeight={'bold'} className="mt-3">Services:</Typography>
                            {[1, 2, 3, 4, 5].map((row) => (
                                <Grid className='productService' container alignItems={'center'}>
                                    <div className="col-10">
                                        <Typography fontSize={19}>Haircut by Shefs</Typography>
                                        <Typography fontSize={15} color="gray">45 mins</Typography>
                                        <Typography fontSize={17} className="mt-2">₹1,500</Typography>
                                    </div>
                                    <div className="col-2">
                                        <button className="btn-service float-end">Book</button>
                                    </div>
                                </Grid>
                            ))}
                            <br />
                            <br />
                            <br />
                            <br /> */}
                            {/* </div> */}
                            {/* <input type="time" /> */}
                            {/* <TextField type="time" /> */}

                        </div>
                    </div>
                    {/* <br /> */}
                    {/* <Grid mt={4} className="col-6 pt-3 ps-5" overflow={'scroll'} height={'84vh'} borderRadius={3}>
                        <Typography fontWeight={'bold'} variant="h4">{data.Name}</Typography>
                        <Typography className="mt-3" color="grey" fontWeight={'bold'} variant="h5">+91 {data.Phone}</Typography> */}
                    {/* <div className="row m-0 w-100 justify-content-between mt-3"> */}

                    {/* <button className="btn-service col-3"><MiscellaneousServices /> Services</button> */}

                    {/* <div className="col-5">
                                <button onClick={handleOpen} className="btn-service"><CalendarMonth /> &nbsp;Book Appointment
                                </button>
                                <Modal
                                    open={modal}
                                    onClose={handleClose}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box sx={style}>
                                        {(currentSection == 0) ? (
                                            <>
                                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                                    Choose Service(s)
                                                </Typography>
                                                <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                                                    {services.map((row) => (
                                                        <div className="d-flex justify-content-between mt-1 align-items-center">
                                                            <div className="col-4">{row.Name}</div>
                                                            <div className="col-4"><span className="float-end">${row.Price}</span></div>
                                                            <div className="col-4">
                                                                {cart.indexOf(row) != -1 ? (
                                                                    <button onClick={() => removefromcart(row)} className="btn btn-info float-end">remove</button>
                                                                ) : (
                                                                    <button onClick={() => addtocart(row)} className="btn btn-navy float-end">Select</button>
                                                                )} */}
                    {/* {cart.some(item => item.Name === row.Name) ? ( */}
                    {/* <button className="btn btn-info">Added</button> */}
                    {/* ) : ( */}
                    {/* <button onClick={() => addtocart(row)} className="btn btn-navy float-end">Select</button> */}
                    {/* )} */}
                    {/* </div>
                                                        </div>
                                                    ))}
                                                    <div className="d-flex flex-wrap justify-content-between mt-3 align-items-center">
                                                        <Typography variant="h6" className="col-8">Total Money(to be paid at Shop):</Typography>
                                                        <Typography variant="h6" className="col-4" textAlign={'right'}>${Totalsum}</Typography>
                                                        <Typography variant="h6" className="col-8">Time Duration:</Typography>

                                                        <Typography className="col-4" variant="h6" textAlign={'right'}>{Totaltime} mins</Typography>
                                                    </div>
                                                    <button className="btn btn-navy mt-3 float-end px-3" onClick={() => setcurrentSection(1)} disabled={(cart.length == 0)}>Next</button>

                                                </Typography>
                                            </>
                                        ) : currentSection == 1 ? (
                                            <>



                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </Box>
                                </Modal>
                            </div>
                            <button className="btn-service col-3"><Directions /> Directions</button>
                        </div>
                        <Typography variant="h4" className="px-4 mt-4">Reviews</Typography>
                        <div className="row m-0 px-4 my-3 align-items-center">
                            <Typography className="col-2" variant="h3">5</Typography>
                            <div className="col-lg-10">
                                <div className="row m-0 align-items-center justify-content-between">
                                    <Typography variant="h6" className="col-1">5</Typography><LinearProgress color="warning" className="col-10" variant="determinate" value={55} />
                                </div>
                                <div className="row m-0 align-items-center justify-content-between">
                                    <Typography variant="h6" className="col-1">4</Typography><LinearProgress color="warning" className="col-10" variant="determinate" value={10} />
                                </div>
                                <div className="row m-0 align-items-center justify-content-between">
                                    <Typography variant="h6" className="col-1">3</Typography><LinearProgress color="warning" className="col-10" variant="determinate" value={13} />
                                </div>
                                <div className="row m-0 align-items-center justify-content-between">
                                    <Typography variant="h6" className="col-1">2</Typography><LinearProgress color="warning" className="col-10" variant="determinate" value={15} />
                                </div>
                                <div className="row m-0 align-items-center justify-content-between">
                                    <Typography variant="h6" className="col-1">1</Typography><LinearProgress color="warning" className="col-10" variant="determinate" value={7} />
                                </div>
                            </div>
                        </div>
                        {[1, 2, 3].map((row, index) => (
                            <>
                                <Grid sx={index == 0 ? { borderBottom: '1px solid black', borderTop: '1px solid black' } : { borderBottom: '1px solid black' }} className='py-3 px-4'>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <Typography fontWeight={600} fontSize={17}>Sunny R. <Typography fontSize={14} className="text-secondary  d-inline ms-1" fontWeight={500}>6 months ago</Typography></Typography>
                                        <Rating readOnly value={5} />
                                    </div>
                                    <Typography fontSize={14} className="mt-2">
                                        Voluptate aliqua amet anim veniam. Non repre henderit com modo minim pro ident reprehenderit duis excepteur cillum anim veniam aliquip magna. Quis sunt ad
                                    </Typography>
                                </Grid>
                                <Grid sx={index != 2 ? { borderBottom: '1px solid black' } : {}} className='px-4 mt-3 pb-4'>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <Typography fontWeight={600} fontSize={17}>Lorem Impsum <Typography fontSize={14} className="text-secondary  d-inline ms-1" fontWeight={500}>1 month ago</Typography></Typography>
                                        <Rating readOnly value={4} emptyIcon={<StarBorder sx={{ color: 'white' }} />} />
                                    </div>
                                    <Typography fontSize={14} className="mt-2">
                                        aliqua amet anim veniam. Non henderit com modo minim pro ident reprehenderit duis excepteur cillum anim veniam aliquip magna. Quis sunt ad
                                    </Typography>
                                </Grid>
                            </>
                        ))}
                        <button data-bs-toggle='modal' data-bs-target='#rating' className="btn-service w-100 radius-0">
                            <center className="w-100">
                                Add Review
                            </center>
                        </button>
                    </Grid> */}
                    <div id="rating" className="modal fade">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="card p-3">
                                    <Typography variant="h5">Add Review</Typography>
                                    <form onSubmit={addReview} className="mt-3">
                                        <textarea placeholder="Enter your review" name="review" className="form-control resize-none" rows={3}></textarea>
                                        <div className="d-flex flex-wrap align-items-center justify-content-between mt-2">
                                            <Rating className="" defaultValue={3} name="rating" precision={1} />
                                            <button className="btn-service rounded px-5">Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid>
                {/* </Grid> */}
                <Footer />
            </Grid >

        </>
    )

}